import Login from "../Components/Login";
import Ylogin from "../Components/Ylogin";
import GF from "../Components/GF";
import MK from "../Components/MK";
import MkSelf from "../Components/MkSelf";
import View from "../Components/View";
import Result from "../Components/Result";
import Countdown from "../Components/Countdown";
import Demo from "../Components/Demo";


 let Route1=[
    {
      path:'/',
      component:Login,
      exact:true
      
     
    },{
      path:'/Ylogin',
      component:Ylogin
     
      
    },
    {
     path:'/MK',
     component:MK
    
     
   },
   {
    path:'/GF',
    component:GF
   
    
  },
   {
    path:'/MkSelf',
    component:MkSelf
   
    
  },
   {
    path:'/Result',
    component:Result
   
    
  },
  {
    path:'/View',
    component:View
   
    
  },
  {
    path:'/Countdown',
    component:Countdown
   
    
  },
  {
    path:'/Demo',
    component:Demo
   
    
  }
  ];

  export default Route1;